module.exports = __webpack_public_path__ + "static/img/guide-13.628d9de8.png";